import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.js';

const ADMIN_EMAIL = 'ccrane2@alumni.nd.edu';

// Direct links into specific, stable Board Playground scenarios (see
// BoardPlayground.js's SCENARIOS/?scenario= handling) -- a quick way to
// jump straight to a particular board state while iterating on UI design,
// without re-clicking through the scenario buttons every time.
const LINKS = [
  { to: '/dev/board-playground?scenario=empty-round1', label: 'Game board empty, round 1 start' },
  { to: '/dev/board-playground?scenario=full-round1-end', label: 'Game board full, end of round 1' },
  { to: '/dev/board-playground?scenario=skeleton', label: 'Game board skeleton UI' },
];

export default function DesignIndex() {
  const { currentUser, authLoaded } = useAuth();

  if (!authLoaded) return <p>Loading…</p>;
  if (currentUser?.email !== ADMIN_EMAIL) return <Navigate to="/" replace />;

  return (
    <div className="panel w-100">
      <div className="mb-3">
        <Link to="/dev">← Dev</Link>
      </div>
      <h2 className="section-title mb-3">Design (dev only)</h2>
      <ul>
        {LINKS.map(link => (
          <li key={link.to}>
            <Link to={link.to}>{link.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
